import { type Result, success } from '@orus.eu/result'

import { type DimensionValidationProblem, dimensionValidationFailure } from './abstract-dimension.ts'
import { AbstractNumberDimension } from './abstract-number-dimension.ts'

export class IntegerDimension<NAME extends string> extends AbstractNumberDimension<NAME> {
  validateNumber(value: number): Result<number, DimensionValidationProblem> {
    return Number.isSafeInteger(value)
      ? success(value)
      : dimensionValidationFailure(`Field ${this.name} is not a safe integer`)
  }

  override formatToString(value: number): string {
    return value.toString()
  }
}
